function setupToggleButton(btn) {
  if (!btn.hasAttribute('aria-expanded')) {
    if (!btn.hasAttribute('data-target')) {
      btn.setAttribute('aria-expanded', 'false');
    }
    btn.expanded = false;
  } else {
    btn.expanded = btn.getAttribute('aria-expanded') === 'true';
  }

  // Listener para clique
  btn.addEventListener('click', function(event) {
    event.preventDefault();

    if (btn.hasAttribute('aria-controls') || btn.hasAttribute('data-target')) {
      btn.expanded = !(btn.getAttribute('aria-expanded') === 'true');

      let target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) {
        target = document.getElementById(btn.getAttribute('data-target'));
      } else {
        return;
      }

      if (target) {
        target.dispatchEvent(new CustomEvent('toggle', {
          detail: {
            expanded: !btn.expanded
          }
        }));
      }

      if (!btn.hasAttribute('data-target')) {
        btn.setAttribute('aria-expanded', !btn.expanded);
      }
    }
  });

  btn.addEventListener('set-expanded', (event) => {
    btn.setAttribute('aria-expanded', event.detail.expanded);
  });
}

document.querySelectorAll('button[data-target], button[aria-controls]').forEach(setupToggleButton);

// Function to set up toggle links
function setupToggleLink(btn) {
  btn.addEventListener('click', function(event) {
    event.preventDefault();
    const parentElement = btn.closest('div');
    // Toggle class on the parent element
    if (parentElement) {
      parentElement.classList.toggle('toggle-open');
    }
    
  });
}
document.querySelectorAll('.store-location-link-toggle').forEach(setupToggleLink);